import React, { useContext, useEffect, useCallback } from 'react';
import { AppContext, DispatchContext } from '../../AppContext';
import * as actions from '../../actions/actions';
import SourcePanelDetails from '../../components/SourcePanelDetails';
import SourceData from '../../components/SourceListPannel';
import ReportDetails from '../../components/ReportDetails';
import { makeStyles } from '@material-ui/styles';
import Service from "../../services/service";
import CompareSource from '../../components/CompareSource';
import { Typography, CircularProgress} from '@material-ui/core';
import TitleBar from '../../components/titleBar';
import { useParams } from "react-router-dom";
import { resolveNotificationMessage } from '../../helpers/constants';

let intervalGetReportSource = null;

export default function ReportReview() {

    const useStyles = makeStyles(theme => ({
        root: {
            position: "relative",
            display: 'flex',
            flexDirection: 'column',
            height: '100%',

        },
        main_container: {
            flexGrow: 1,
            display: 'flex',
            justifyContent: "space-between",
            overflow: 'hidden',
            overflowX: 'auto',
        },
        helper_container: {
            left: 0,
            right: 0,
            bottom: 0,
            display: "flex",
            zIndex: -1,
            opacity: 1,
            transition: "opacity 225ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
            position: "fixed",
            alignItems: "center",
            touchAction: "none",
            justifyContent: 'center',
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            webkitTapHighlightColor: "transparent",
        },
        reportStatusContainer: {
            maxWidth: 500,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            opacity: 1,
            transition: "opacity 225ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
        },
        colorPrimary: {
            color: "white",
            size: "70px"
        },
        containerSizeLeft: {
            width: '375px',
            minWidth: "375px",

        },
        containerSizeRight: {
            display: (state) => state.ui.propertyBarVisible ? "block" : "none",
            width: 350,
            minWidth: 350,
        },

        containerSizePanelDetail: {
            flex: '1 1 auto',
        },
        overlay: {
            zIndex: "99",
            right: "0px",
            top: "0",
            left: "0",
            bottom: "0",
            display: "flex",
            justifyContent: "center",
            position: "absolute",
            backgroundColor: "rgba(0,0,0,0.6)",
        },
        reportStatusPosition: {
            color: "white",
            fontSize: "16px",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
        },
        loader: {
            color: "white",
            textAlign: "center"
        },
        displayFlex: {
            display: "flex"
        },
        flexDirection: {
            display: "flex",
            flexDirection: "column"
        },

    }));

    const dispatch = useContext(DispatchContext);
    const [openSideBySideCompare, setOpenSideBySideCompare] = React.useState(false);
    const [reportStatus, setReportStatus] = React.useState({});
    const state = useContext(AppContext);
    const s = state.strings;
    const classes = useStyles(state);
    let { id } = useParams();

    // get API data while page load
    useEffect(() => {
        if (!state.activeReportId) {
            dispatch(actions.navigate_to("/plagiarism/reports/" + id));
            dispatch(actions.change_report_card(id));
            dispatch(actions.setUI({ plagCheckMenuExpanded: true }));
        }
        if (state.activeReportId) {
            dispatch(actions.setSourceFilter({
                onlineSource: true,
                librarySource: true,
                acceptedSource: true,
                suspiciousSource: true,
                excludedSource: false,
                duplicatedSource: false,
                searchTextValue: "",
                sortBy: 1
            }))
        }
        state.activeReportId && Service.getReport(state.activeReportId, false, state.ui.permaLinkId).then(res => {
            if (res.success) {
                dispatch(actions.get_report(res.data || []));
            }
            if (res.data && res.data.Status && !intervalGetReportSource && res.data.Status.toLowerCase() != "ok") {
                intervalGetReportSource = setInterval(() => {
                    Service.getReportStatus(state.activeReportId).then(res => {
                        if (res.success) {
                            clearInterval(intervalGetReportSource);
                            intervalGetReportSource = null;
                            Service.getReport(state.activeReportId, false, state.ui.permaLinkId).then(res => {
                                if (res.success) {
                                    dispatch(actions.get_report(res.data || []));
                                }
                            });
                        }
                        else {
                            setReportStatus(res.data);
                        }
                    })
                }, 2000);
            }
        });

        state.activeReportId && state.activeReport.Status == "Ok" && Service.getSources(state.activeReportId, state.ui.permaLinkId).then(res => {
            if (res.success && res.data) {
                dispatch(actions.setSources(res.data.length > 0 ? res.data : [] || []));
            }
        });

        state.activeReportId && state.activeReport.Status == "Ok" && Service.getReportMarkup(state.activeReportId, state.ui.permaLinkId).then(res => {
            if (res.success) {
                dispatch(actions.get_report_markup(typeof res.data == 'string' ? [] : res.data || []))
            }
        });

        state.activeReportId && state.activeReport.Status == "Ok" && Service.getOverlayStatistics(state.activeReportId, state.ui.permaLinkId).then(res => {
            if (res.success) {
                dispatch(actions.set_overlay_statistics(typeof res.data == 'string' ? [] : res.data || []))
            }
        });

        return () => {
            clearInterval(intervalGetReportSource);
            intervalGetReportSource = null;
        };
    }, [state.activeReportId, state.activeReport.Status]);

    // reload all report data (typically called after rating changed)
    const reloadReport = useCallback(() => {
        Service.getSources(state.activeReportId, state.ui.permaLinkId).then(res => {
            if (res.success) {
                dispatch(actions.setSources(res.data || []));
            }
        });
        Service.getReport(state.activeReportId, false, state.ui.permaLinkId).then(res => {
            if (res.success) {
                dispatch(actions.get_report(res.data || []));
            }
        });
        state.activeReportId && Service.getReportMarkup(state.activeReportId, state.ui.permaLinkId).then(res => {
            if (res.success) {
                dispatch(actions.get_report_markup(typeof res.data == 'string' ? [] : res.data || []))
            }
        });
        state.activeReportId && Service.getOverlayStatistics(state.activeReportId, state.ui.permaLinkId).then(res => {
            if (res.success) {
                dispatch(actions.set_overlay_statistics(typeof res.data == 'string' ? [] : res.data || []))
            }
        });
    });

    // Scoll page While hover source detail and source list
    const scrollToContent = (content, id) => {
        switch (content) {
            case 2:
                let section1 = document.getElementById(id);
                if (section1) {
                    section1.scrollIntoView({ behavior: "smooth", block: 'start', inline: 'nearest' });
                    return false;
                }
                break;
            case 1:
                let section2 = document.getElementById(id);
                if (section2) {
                    section2.scrollIntoView({ behavior: "smooth", block: 'end', inline: 'end' })
                    return false;
                };
                break;
        }
    }

    // Hover in effect source details and Source list
    const hoverToContent = (content, id) => {
        id = String(id);
        const IdClass = document.getElementsByClassName(id);
        if (IdClass) {
            for (let i = 0; i < IdClass.length; i++) {
                if (isNaN(id) && id.includes('list')) {
                    IdClass[i].style.border = "1px solid blue";
                } else {
                    IdClass[i].style.zIndex = "100";
                    IdClass[i].style.border = "1px solid blue";
                }
            }
        }
    }

    // Hover out effect source details and Source list
    const hoverToOutContent = (content, id) => {
        id = String(id);
        const IdClass = document.getElementsByClassName(id);
        if (IdClass) {
            for (let i = 0; i < IdClass.length; i++) {
                if (id.includes('list')) {
                    IdClass[i].style.border = "1px solid #dddddd";
                } else {
                    IdClass[i].style.border = "1px solid white";
                    IdClass[i].style.zIndex = "10";
                }
            }
        }
    }

    const onHandleChange = (value, id) => {
        if (value) {
            Service.getSourceMarkup(id, state.ui.permaLinkId).then(res => {
                if (res.success && res.data) {
                    dispatch(actions.setSourceMarkup(res.data));
                }
                else {
                    dispatch(actions.openToast({ type: "error", message: "Comparsion Data not Found!", status: true }));
                }
            });
        }
        else {
            dispatch(actions.setSourceMarkup({}));
        }
        setOpenSideBySideCompare(value);
    }

    if (!state.activeReportId) {
        return (
            <div>
                Select Report Id First
            </div>
        )
    }

    const activeReportState = (reportStatus) => {

        return (reportStatus.statusMsg) && 
            (reportStatus.statusMsg == "stateActive" || reportStatus.statusMsg == "stateScheduled" || reportStatus.statusMsg == "stateCompile");
    }

    return (
        <div className={classes.root}>
            {openSideBySideCompare && <CompareSource open={openSideBySideCompare} onHandleClose={onHandleChange} reloadReport={reloadReport} />}

            {/* Overlay Start */}
            {state.activeReport && state.activeReport.Status != "Ok" && <div className={classes.overlay}>
                <div className={classes.helper_container}></div>
                <div className={classes.reportStatusContainer}>
                    <div>
                        <div className={classes.loader}>
                            {(!reportStatus.statusMsg || activeReportState(reportStatus)) && <CircularProgress color="inherit" size="70px" style={{ marginBottom: 16 }} />}
                        </div>
                        <div className={classes.reportStatusPosition}>
                            <div>{reportStatus.statusMsg && resolveNotificationMessage(reportStatus.statusMsg, s.reportReview)}</div>
                            <div>{reportStatus.statusMsg && (reportStatus.statusMsg == "stateActive") && s.reportReview.snapsDone.format(reportStatus.snapsDone, reportStatus.snapsCount)}</div>
                            <Typography align="center" variant="body2" style={{ marginTop: 32 }}>
                                { activeReportState(reportStatus) && s.reportReview.activeHint }
                                { reportStatus.statusCode && resolveNotificationMessage(reportStatus.statusCode, s.notificationMessage) }
                            </Typography>
                        </div>
                    </div>
                </div>
            </div>}

            {/* Overlay End */}
            <TitleBar title={state.activeReport.Name} type="ReportReview" />
            <div className={classes.main_container}>
                <div className={classes.containerSizeLeft}>
                    <SourcePanelDetails
                        scrollToContent={(Id) => scrollToContent(2, Id)}
                        handleOpen={onHandleChange}
                        reloadReport={reloadReport}
                        hoverToContent={(Id) => hoverToContent(2, Id)}
                        hoverToOutContent={(Id) => hoverToOutContent(2, Id)}
                    />
                </div>
                <div className={classes.containerSizePanelDetail}>
                    <SourceData scrollToContent={(SId) => scrollToContent(1, SId)}
                        handleOpen={onHandleChange}
                        hoverToContent={(SId) => hoverToContent(1, SId)}
                        hoverToOutContent={(SId) => hoverToOutContent(2, SId)}
                    />
                </div>
                <div className={classes.containerSizeRight}>
                    <ReportDetails onResetReport={reloadReport} />
                </div>
            </div>
        </div>
    );

}

